import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { apiHandler } from '../lib/apiHandler';
import { ResellingProduct, ResellingPrograms } from '../type';

const url = () => pathfinder('reselling_create_order');

interface CreateSubscriptionArgs extends Pick<ResellingProduct, 'country' | 'billingTerm' | 'billingCycle'> {
    programId: ResellingPrograms['id'];
    sellerId: ResellingPrograms['sellerId'];
    productId: ResellingProduct['id'];
    quantity: number;
    isDiscountApplied: boolean;
}

interface CreateSubscriptionResponse {
    data: CreateSubscriptionResponseData;
}

interface CreateSubscriptionResponseData {
    paymentSessionId: string;
}

export const createMicrosoft365Subscription = apiHandler(
    async ({
        programId,
        productId,
        country,
        billingCycle,
        billingTerm,
        sellerId,
        quantity,
        isDiscountApplied,
    }: CreateSubscriptionArgs) => {
        const { data } = await axios.post<CreateSubscriptionResponse>(url(), {
            programId,
            productId,
            country,
            billingCycle,
            billingTerm,
            sellerId,
            quantity,
            isDiscountApplied,
        });

        return data.data.paymentSessionId;
    },
    `client.reselling_kimera.create_microsoft_365_subscription`
);
